"use strict";

(() => {
  // 閲覧履歴
  const $browsingHistory = $('#js-browsing-history')
  const $browsingHistoryBlackLayer = $('#js-browsing-history-black-layer')
  const $toggleBtn = $('#js-browsing-history-toggle-btn')
  // リスト全体
  const $browsingHistoryBox = $('#js-browsing-history-box')
  const $noBrowsingHistoryBox = $('#js-no-browsing-history-box')
  // 個社ページボタン
  const $browsingHistoryBtn = $('#js-browsing-history-btn')
  const $noBrowsingHistoryBtn = $('#js-no-browsing-history-btn')
  // 作品&作品グループのidとtype取得先
  const $browsingHistoryLibraryId = $('#js-browsing-history-library-id')
  // 閲覧履歴リスト
  const $browsingHistoryList = $('#js-browsing-history-list')
  // 閲覧履歴リスト数
  const $browsingHistoryCount = $('#js-browsing-history-count')

  const storageKey = 'browsing-history'

  let BrowsingHistoryArray = []

  // template - list
  const listTemplate = (param) => {
    /**
     * param.title
     * param.href
     * param.thumb
     * param.credit
     * param.deeplink
     */

    let prBtn
    let listBtns = new String()
    let template
    let btnLength

    if(param.deeplink != '') {
      // 配信個社がある場合
      // pr btn
      const prImgPath = location.origin + '/assets/common/img/brand/logo/' + param.deeplink[0].slug + '.png'
      prBtn = '<a href="' + param.deeplink[0].href + '" class="pr-btn" rel="nofollow" target="_blank">' +
                '<img src="' + prImgPath + '">' + param.deeplink[0].trial +
              '</a>'

      // list btns
      if(param.deeplink.length > 6) {
        btnLength = 7
      } else {
        btnLength = param.deeplink.length
      }

      for(let i = 1; i < btnLength; i++) {
        const imgPath = location.origin + '/assets/common/img/brand/logo/' + param.deeplink[i].slug + '.png'
        const template = '<li class="btn-list__item">' +
                            '<a href="' + param.deeplink[i].href + '" rel="nofollow" target="_blank">' +
                              '<img src="' + imgPath + '">' +
                            '</a>' +
                          '</li>'
        listBtns += template
      }

      template = '<li class="browsing-history-list__item">' +
                    '<a href="' + param.href + '" class="thumb">' +
                        '<img src="' + param.thumb + '">' +
                    '</a>' +
                    '<div class="library-detail-box">' +
                        '<div class="credit">' + param.credit + '</div>' +
                        '<a href="' + param.href + '" class="title">' + param.title + '</a>' +
                    '</div>' +
                    '<div class="btn-box">' + prBtn +
                        '<ul class="btn-list">' + listBtns +
                        '</ul>' +
                    '</div>' +
                '</li>'
    } else {
      // 配信個社がない場合
      template = '<li class="browsing-history-list__item">' +
                    '<a href="' + param.href + '" class="thumb">' +
                        '<img src="' + param.thumb + '">' +
                    '</a>' +
                    '<div class="library-detail-box">' +
                        '<div class="credit">' + param.credit + '</div>' +
                        '<a href="' + param.href + '" class="title">' + param.title + '</a>' +
                    '</div>' +
                    '<div class="btn-box btn-box--no-vods"></div>' +
                '</li>'
    }
    return template
  }

  // template - btn
  const btnTemplate = (param) => {
    /**
     * param.slug
     * param.href
     * param.short_name
     */

    if(param == undefined) return
    const imgPath = location.origin + '/assets/common/img/brand/logo/square/' + param.slug + '.png'
    const template = '<a href="' + param.href + '" class="cv-btn">' +
                        '<img src="' + imgPath + '">今すぐ無料体験へ' +
                      '</a>'
    return template
  }

  // localStorage取得
  const getStorage = (key) => {
    const obj = localStorage.getItem(key)
    return JSON.parse(obj)
  }

  // localStorage保存
  const saveStorage = (key, val) => {
    localStorage.setItem(key, JSON.stringify(val))
  }

  // localStorageセット
  const setStorage = (datas) => {
    for(const data of datas) {
      let obj = {
        id: data.id,
        type: data.type
      }
      BrowsingHistoryArray.push(obj)
      saveStorage(storageKey, BrowsingHistoryArray)
    }
  }

  // Save localStorage
  const saveBrowsingHistory = (id, type) => {
    // 最新の閲覧履歴
    const obj = {
      id: id,
      type: type
    }
    // TODO: 最新の閲覧履歴が古い閲覧履歴と重複していたら配列に含めない
    // TODO: 最大20件
    const BrowsingHistoryDatas = getStorage(storageKey)

    if(BrowsingHistoryDatas != undefined) {
      // 重複する閲覧履歴がある場合は、その閲覧履歴を削除
      for(let i = 0; i < BrowsingHistoryDatas.length; i++) {
        if(id == BrowsingHistoryDatas[i].id && type == BrowsingHistoryDatas[i].type) {
          BrowsingHistoryDatas.splice(i, 1)
        }
      }
      // 重複する閲覧履歴がない場合
      // 閲覧履歴が20件以上になるの場合、最新閲覧履歴の追加前に最後の20件目を削除
      if(BrowsingHistoryDatas.length >= 19) {
        BrowsingHistoryDatas.splice(19, 1)
      }
      // BrowsingHistoryArrayに再設定
      BrowsingHistoryArray = BrowsingHistoryDatas;
    }
    // リストの先頭に最新の閲覧履歴を追加
    BrowsingHistoryArray.unshift(obj)
    saveStorage(storageKey, BrowsingHistoryArray)
  }

  const createBrowsingHistoryList = () => {
    // Add list ui
    // GET
    const browsingHistoryJson = getStorage(storageKey)

    fetch(encodeURI('/browsingHistory/getLibrary/?data=' + JSON.stringify(browsingHistoryJson)), {
      method: 'GET',
      headers: {
        "Content-Type": "application/json;",
        'X-Requested-With': 'XMLHttpRequest',
      },
    }).then(function(res) {
      if (res.status === 200) {
        res.json().then((result) => {
          // TODO 画面に描画する
          if(result.count == 0) {
            // 閲覧履歴がない場合の表示/非表示
            $browsingHistoryBox.removeClass('open');
            $noBrowsingHistoryBox.addClass('open');
            $browsingHistoryBtn.removeClass('open');
            $noBrowsingHistoryBtn.addClass('open');
            return
          }
          // 閲覧履歴がある場合の表示/非表示
          $browsingHistoryBox.addClass('open');
          $noBrowsingHistoryBox.removeClass('open');
          // 閲覧履歴の配信個社がない場合
          if(result.vods.length <= 0) {
            $browsingHistoryBtn.removeClass('open');
            $noBrowsingHistoryBtn.addClass('open');
          } else {
            $browsingHistoryBtn.addClass('open');
            $noBrowsingHistoryBtn.removeClass('open');
          }
          // 作品閲覧履歴数
          $browsingHistoryCount.text(result.count + '作品')
          // 作品閲覧履歴リストを空にする
          $browsingHistoryList.empty();

          // 作品閲覧履歴
          for(const data of result.data) {
            let deeplink = ''

            // 低品質ページではない情報をリストに追加
            if(data.is_show_detail_status !== 0) {
              // 閲覧した作品の各配信個社情報
              if(data.vods.length > 0) {
                deeplink = data.vods
              }

              let param = {
                title: data.title,
                href: data.href,
                thumb: data.thumbnail,
                credit: data.library_thumbnail_credit_box_html,
                deeplink: deeplink
              }

              const template = listTemplate(param)
              $browsingHistoryList.append(template)
            }
          }
          // 配信個社（SPは1社目のみ）
          const template = btnTemplate(result.vods[0])
          $browsingHistoryBtn.html(template);
        })
      }
    }).catch(function(res) {
      console.log(res);
    });
  }

  const addBrowsingHistory = () => {
    const id = $browsingHistoryLibraryId.attr('data-library-id')
    const type = $browsingHistoryLibraryId.attr('data-library-type')

    saveBrowsingHistory(id, type)
    createBrowsingHistoryList()
  }

  const loadBrowsingHistory = () => {
    // ページ読み込み時にリストUIを復活させる
    const BrowsingHistoryDatas = getStorage(storageKey)

    if(BrowsingHistoryDatas == null) return

    // 閲覧履歴をセット
    setStorage(BrowsingHistoryDatas)
  }
  loadBrowsingHistory()

  // URLがlibraryページの場合のみ、保存と閲覧リストUIの追加
  if($browsingHistoryLibraryId.length > 0) {
    addBrowsingHistory();
  } else {
    createBrowsingHistoryList()
  }

  // モーダル表示/非表示
  $toggleBtn.on('click', () => {
    $browsingHistory.toggleClass('open');
    $browsingHistoryBlackLayer.toggleClass('open');
  })
  $browsingHistoryBlackLayer.on('click', () => {
    $browsingHistory.toggleClass('open');
    $browsingHistoryBlackLayer.toggleClass('open');
  })
})()